import { Box, Grid, Paper, Text } from '@mantine/core';
import { sumBy } from 'lodash';
import React, { useMemo } from 'react';

import { UTB_REPORT_DECIMAL_PLACES } from '../constants';
import { TaxSummary } from '../resources';
import { TranslationFn } from '../translations';

interface UTBTotalProps {
  resources: TaxSummary[];
  t: TranslationFn;
}

export const UTBTotal = ({ resources, t }: UTBTotalProps) => {
  const total = useMemo(() => sumBy(resources, (resource) => resource.total || 0), [resources]);

  return (
    <Paper withBorder mb="xs">
      <Box p="xs">
        <Grid>
          <Grid.Col span={3}>
            <Text>{t('TOTAL.INVITATIONS')}</Text>
          </Grid.Col>
          <Grid.Col span={9} />
        </Grid>
        <Grid>
          <Grid.Col span={3} />
          <Grid.Col span={6}>
            <Text>{t('TOTAL.DUE')}</Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <Text>€ {total ? total.toFixed(UTB_REPORT_DECIMAL_PLACES) : 'NIHIL'}</Text>
          </Grid.Col>
        </Grid>
      </Box>
    </Paper>
  );
};
